import { ApiCall, ParameterTypes } from '@lcms/api-definition';
import endpoints from '../api-endpoint-definition.json';
import { ApiResponse } from './api-response';

const definition = new ApiCall<ApiResponse>().post('setTrendingSearchTermsSticky', { 
    route: endpoints.adminTrendingSearchTermsSticky,
    params: {
        id: {
            type: ParameterTypes.String
        },
        sticky: {
            type: ParameterTypes.Boolean
        }
    }
})
export default definition;